import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import {
  ListagemUsuarios, DetalheUsuario, ListagemPermissao, PlanoDeContas, ListagemDeParceiros, DetalheDeParceiros, ListagemDeTransportadoras, DetalheDaTransportadora,
  ListagemDeReboques,
  DetalheDeReboques,
  ListagemDeVeiculos,
  DetalheDeVeiculos,
  ListagemDeContaBancaria,
  DetalheDeContaBancaria,
  DetalheDeEmpresa
} from '../pages/cadastros';
import {
  ListagemDeGrupoDeProdutos, ListagemDeSubGrupoDeProdutos, ListagemDeProdutos, ListagemDeEntradas, DetalheDaEntrada, ListagemDeVenda, DetalheDeVenda,
  ListagemDeOperacoes,
  RelatoriosVendas,
  RelatorioEstoque,
  DashboardComissao,
  DashboardVendas,
  DashboardEvolucaoVendas,
  DashboardProdutos,
  MovimentoDoProduto,
  DashboardEstoque,
  ListagemEstoqueMinimo,
} from '../pages/Estoque';
import {
  ListagemContasReceber, DetalheDeReceber, DetalheDePagar, ListagemContasPagar, Conciliacao, ListagemEntreContas, DetalheDeEntreContas, RelatoriosContasReceber, RelatoriosContasRecebidas, RelatoriosContasPagar,
  RelatoriosContasPagas,
  DashboardContas,
  ListagemDeSessoesAbertas,

} from '../pages/Financeiro';
import { ListagemFaturamento, ListagemDeNfe, DetalheDaNfe, ListagemDeNfeDistribuida, ListagemDeNotasCompra, ListagemDeNfeEntrada, DetalheDaNfeEntrada, RelatoriosNfe, ListagemDeNfce, RelatoriosNfce, DashboardNotas, RelatoriosFiscalProdutos, ListagemDeMdfe, DetalheDeMdfe, SpedFiscal } from '../pages/fiscal';
import { ListagemDeBens, DetalheDeBem, ListagemDeOrdensServico, DetalheDeOrdemServico } from '../pages/Servicos';
import { IDrawerItemOption, IDrawerOption, moduloDaRota, moduloDoMenu, useDrawerContext, useModulosEmpresa } from '../shared/contexts';
import { TModuloEmpresa } from '../shared/services/api/cadastros/ModulosEmpresaService';
import { DetalheDeProduto } from '../pages/Estoque/produtos/DetalheDeProduto';
import { PaginaInicial } from '../pages/inicio';
import { registrarAcesso } from '../shared/services/util/registroDeAcessos';

export const AppRoutes = () => {
  const { setDrawerOptions, setDrawerItemOptions } = useDrawerContext();
  const { modulos, moduloLiberado, rotaLiberada } = useModulosEmpresa();
  const location = useLocation();

  // Registra as telas abertas pra ordenar os "Acessos rápidos" do painel inicial.
  useEffect(() => {
    registrarAcesso(location.pathname);
  }, [location.pathname]);

  // Módulos que a empresa não contratou (painel de controle) somem do menu —
  // o módulo e todos os itens dele. Enquanto os módulos não carregam, o menu
  // mostra só o Início, pra nada aparecer e sumir em seguida.
  useEffect(() => {
    const menuLiberado = (path: string) => {
      const modulo = moduloDoMenu(path);
      return !modulo || moduloLiberado(modulo);
    };

    const modulosDoMenu: IDrawerOption[] = [
      {
        label: 'Início',
        icon: 'home',
        path: '/inicio',
      },
      {
        label: 'Vendas',
        icon: 'point_of_sale',
        path: '/vendas',
      },
      {
        label: 'Cadastros',
        icon: 'folder',
        path: '/cadastros',
      },

      {
        label: 'Estoque',
        icon: 'symbols:pallet',
        path: '/estoque',
      },
      {
        label: 'Financeiro',
        icon: 'symbols:payments',
        path: '/financeiro',
      },
      {
        label: 'Fiscal',
        icon: 'account_balance',
        path: '/fiscal',
      },
      {
        label: 'Serviços',
        icon: 'build',
        path: '/servicos',
      }
    ];
    setDrawerOptions(modulosDoMenu.filter(opcao => menuLiberado(opcao.path)));

    const itensDoMenu: IDrawerItemOption[] = [
      {
        label: 'Parceiros',
        icon: 'handshake',
        path: '/parceiros',
        parent: '/cadastros',
        descricao: 'Clientes, fornecedores e contatos'
      },
      {
        label: 'Transportadora',
        icon: 'local_shipping',
        path: '/transportadoras',
        parent: '/cadastros',
        descricao: 'Transportadoras e veículos'
      },

      {
        label: 'Operaçoes',
        icon: 'people',
        path: '/operacoes',
        parent: '/cadastros',
        descricao: 'Tipos de operação do sistema'
      },
      {
        label: 'Contas Financeiras',
        icon: 'account_balance',
        path: '/contabancaria',
        parent: '/cadastros',
        descricao: 'Contas bancárias da empresa'
      },
      {
        label: 'Plano de Contas',
        icon: 'schema',
        path: '/planocontas',
        parent: '/cadastros',
        descricao: 'Estrutura do plano contábil'
      },
      {
        label: 'Usuarios',
        icon: 'people',
        path: '/usuarios',
        parent: '/cadastros',
        descricao: 'Usuários e permissões'
      },
      {
        label: 'Gráficos de Vendas',
        icon: 'stacked_line_chart',
        path: '/dashboardevolucaovendas',
        parent: '/vendas',
        descricao: 'Evolução e indicadores de vendas'
      },

      {
        label: 'Venda',
        icon: 'point_of_sale',
        path: '/venda',
        parent: '/vendas',
        descricao: 'Registrar e consultar vendas'
      },

      {
        label: 'Minhas Vendas',
        icon: 'point_of_sale',
        path: '/dashboardcomissao',
        parent: '/vendas',
        modulo: 'comissao',
        descricao: 'Comissões das suas vendas'
      },

      {
        label: 'Vendas da Equipe',
        icon: 'insights',
        path: '/dashboardvendas',
        parent: '/vendas',
        modulo: 'comissao',
        descricao: 'Desempenho de vendas da equipe'
      },
      {
        label: 'Relatorios',
        icon: 'library_books',
        path: '/relatoriovendas',
        parent: '/vendas',
        descricao: 'Relatórios de vendas'
      },
      {
        label: 'Entrada',
        icon: 'input',
        path: '/entrada',
        parent: '/estoque',
        descricao: 'Entradas de mercadoria no estoque'
      },



      {
        label: 'Produtos',
        icon: 'inventory2',
        path: '/produto',
        parent: '/estoque',
        descricao: 'Cadastro de produtos e serviços'
      },
      {
        label: 'Grupo',
        icon: 'webhook',
        path: '/grupo',
        parent: '/estoque',
        descricao: 'Grupos de produtos'
      },
      {
        label: 'SubGrupo',
        icon: 'workspaces',
        path: '/subgrupo',
        parent: '/estoque',
        descricao: 'Subgrupos de produtos'
      },
      {
        label: 'Relatorios',
        icon: 'library_books',
        path: '/relatorioestoque/restoque',
        parent: '/estoque',
        descricao: 'Relatórios de estoque'
      },
      {
        label: 'Gráficos',
        icon: 'insights',
        path: '/dashboardestoque',
        parent: '/estoque',
        descricao: 'Indicadores de estoque'
      },



      {
        label: 'Gráficos',
        icon: 'insights',
        path: '/dashboardcontas',
        parent: '/financeiro',
        descricao: 'Indicadores financeiros'
      },
      {
        label: 'Contas a Receber',
        icon: 'account_balance_wallet',
        path: '/contasreceber',
        parent: '/financeiro',
        descricao: 'Títulos e recebimentos'
      },
      {
        label: 'Contas a Pagar',
        icon: 'request_quote',
        path: '/contaspagar',
        parent: '/financeiro',
        descricao: 'Títulos e pagamentos'
      },
      {
        label: 'Faturamento',
        icon: 'description',
        path: '/faturamento',
        parent: '/financeiro',
        descricao: 'Emissão e controle de faturamento'
      },
      {
        label: 'Conciliação',
        icon: 'syncAlt',
        path: '/conciliacao',
        parent: '/financeiro',
        descricao: 'Conciliação bancária'
      },
      {
        label: 'Sessões Abertas',
        icon: 'point_of_sale',
        path: '/sessoesabertas',
        parent: '/financeiro',
        descricao: 'Consulta de sessões de caixa por número'
      },
      {
        label: 'Lançamento Entre Contas',
        icon: 'currency_exchange',
        path: '/entrecontas',
        parent: '/financeiro',
        descricao: 'Transferências entre contas'
      },
      {
        label: 'Relatorios',
        icon: 'library_books',
        path: '/relatoriofinanceiro/rpagas',
        parent: '/financeiro',
        descricao: 'Relatórios financeiros'
      },


      {
        label: 'Gráficos',
        icon: 'insights',
        path: '/dashboardnotas',
        parent: '/fiscal',
        descricao: 'Indicadores fiscais'
      },

      {
        label: 'NFE Entrada',
        icon: 'move_to_inbox',
        path: '/nfeentrada',
        parent: '/fiscal',
        descricao: 'Notas fiscais de entrada'
      },
      {
        label: 'NFE',
        icon: 'receiptLong',
        path: '/nfe',
        parent: '/fiscal',
        descricao: 'Emissão de notas fiscais'
      },
       {
        label: 'NFC-e',
        icon: 'receiptLong',
        path: '/nfce',
        parent: '/fiscal',
        descricao: 'Cupons fiscais eletrônicos'
      },
      {
        label: 'MDF-e',
        icon: 'local_shipping',
        path: '/mdfe',
        parent: '/fiscal',
        descricao: 'Manifestos eletrônicos de documentos fiscais'
      },

      {
        label: 'NFE Dist',
        icon: 'cloudDownload',
        path: '/nfedist',
        parent: '/fiscal',
        descricao: 'Notas fiscais distribuídas pela SEFAZ'
      },
      {
        label: 'Notas de Compra',
        icon: 'receiptLong',
        path: '/notascompra',
        parent: '/fiscal',
        descricao: 'Notas recebidas da SEFAZ, situação e download'
      },
      {
        label: 'SPED Fiscal',
        icon: 'description',
        path: '/spedfiscal',
        parent: '/fiscal',
        descricao: 'Gerar o arquivo da EFD ICMS/IPI do mês'
      }, {
        label: 'Relatorios',
        icon: 'library_books',
        path: '/relatoriosfiscal/rnfe',
        parent: '/fiscal',
        descricao: 'Relatórios fiscais'
      },

      {
        label: 'Ordens de Serviço',
        icon: 'build',
        path: '/ordensservico',
        parent: '/servicos',
        descricao: 'Abertura e acompanhamento de OS'
      },
      {
        label: 'Bens/Patrimônio',
        icon: 'inventory2',
        path: '/bens',
        parent: '/servicos',
        descricao: 'Veículos, máquinas e patrimônios de clientes'
      },

    ];
    setDrawerItemOptions(itensDoMenu.filter(item => menuLiberado(item.parent) && (!item.modulo || moduloLiberado(item.modulo as TModuloEmpresa))));
  }, [moduloLiberado]);

  // Tela de um módulo não contratado (URL digitada, favorito, atalho F2...)
  // volta pro Início. Enquanto os módulos carregam, telas de módulo esperam
  // em branco em vez de abrir e fechar em seguida.
  if (moduloDaRota(location.pathname)) {
    if (!modulos) return null;
    if (!rotaLiberada(location.pathname)) return <Navigate to="/inicio" replace />;
  }

  return (
    <Routes>
      <Route path="/usuarios" element={<ListagemUsuarios />} />
      <Route path="/usuarios/:id" element={<DetalheUsuario />} />
      <Route path="/usuarios/permissoes/:id/:nome" element={<ListagemPermissao />} />
      <Route path="/planodecontas" element={<PlanoDeContas />} />

      <Route path="/parceiros" element={<ListagemDeParceiros />} />
      <Route path="/parceiros/:id" element={<DetalheDeParceiros />} />

      <Route path="/empresa" element={<DetalheDeEmpresa />} />

      {/* Relatório de vendas saiu do módulo Estoque pro módulo Vendas —
          o endereço antigo (favoritos) leva pro novo. */}
      <Route path="/relatoriovendas" element={<RelatoriosVendas />} />
      <Route path="/relatorioestoque/rvendas" element={<Navigate to="/relatoriovendas" replace />} />
      <Route path="/relatorioestoque/restoque" element={<RelatorioEstoque />} />

      <Route path="/relatoriofinanceiro/rreceber" element={<RelatoriosContasReceber />} />
      <Route path="/relatoriofinanceiro/rrecebidas" element={<RelatoriosContasRecebidas />} />
      <Route path="/relatoriofinanceiro/rpagar" element={<RelatoriosContasPagar />} />
      <Route path="/relatoriofinanceiro/rpagas" element={<RelatoriosContasPagas />} />

      <Route path="/relatoriosfiscal/rnfe" element={<RelatoriosNfe />} />
      <Route path="/relatoriosfiscal/rnfce" element={<RelatoriosNfce />} />
      <Route path="/relatoriosfiscal/rprodutos" element={<RelatoriosFiscalProdutos />} />

      <Route path="/dashboardnotas" element={<DashboardNotas />} />
      <Route path="/dashboardcontas" element={<DashboardContas />} />

      <Route path="/operacoes" element={<ListagemDeOperacoes />} />

      <Route path="/faturamento" element={<ListagemFaturamento />} />
      <Route path="/conciliacao" element={<Conciliacao />} />
      <Route path="/sessoesabertas" element={<ListagemDeSessoesAbertas />} />
      <Route path="/entrecontas" element={<ListagemEntreContas />} />
      <Route path="/entrecontas/:id" element={<DetalheDeEntreContas />} />

      <Route path="/nfe" element={<ListagemDeNfe />} />
      <Route path="/mdfe" element={<ListagemDeMdfe />} />
      <Route path="/mdfe/:id" element={<DetalheDeMdfe />} />
      <Route path="/nfe/:id" element={<DetalheDaNfe />} />

      <Route path="/nfce" element={<ListagemDeNfce />} />

      <Route path="/nfedist" element={<ListagemDeNfeDistribuida />} />
      <Route path="/notascompra" element={<ListagemDeNotasCompra />} />
      <Route path="/spedfiscal" element={<SpedFiscal />} />

      <Route path="/nfeentrada" element={<ListagemDeNfeEntrada />} />
      <Route path="/nfeentrada/:id" element={<DetalheDaNfeEntrada />} />

      <Route path="/grupo" element={<ListagemDeGrupoDeProdutos />} />
      <Route path="/subgrupo" element={<ListagemDeSubGrupoDeProdutos />} />

      <Route path="/produto" element={<ListagemDeProdutos />} />
      <Route path="/produto/:id" element={<DetalheDeProduto />} />
      <Route path="/produto/dashboard/:id" element={<DashboardProdutos />} />
      <Route path="/produto/movimento/:id" element={<MovimentoDoProduto />} />

      <Route path="/dashboardestoque" element={<DashboardEstoque />} />
      <Route path="/estoque/estoqueminimo" element={<ListagemEstoqueMinimo />} />

      <Route path="/contasreceber" element={<ListagemContasReceber />} />
      <Route path="/contasreceber/:id" element={<DetalheDeReceber />} />

      <Route path="/bens" element={<ListagemDeBens />} />
      <Route path="/bens/:id" element={<DetalheDeBem />} />
      <Route path="/ordensservico" element={<ListagemDeOrdensServico />} />
      <Route path="/ordensservico/:id" element={<DetalheDeOrdemServico />} />

      <Route path="/contaspagar" element={<ListagemContasPagar />} />
      <Route path="/contaspagar/:id" element={<DetalheDePagar />} />

      <Route path="/entrada" element={<ListagemDeEntradas />} />
      <Route path="/entrada/:id" element={<DetalheDaEntrada />} />

      <Route path="/dashboardcomissao" element={<DashboardComissao />} />
      <Route path="/dashboardvendas" element={<DashboardVendas />} />
      <Route path="/dashboardevolucaovendas" element={<DashboardEvolucaoVendas />} />
      <Route path="/venda" element={<ListagemDeVenda />} />
      <Route path="/venda/:id" element={<DetalheDeVenda />} />

      <Route path="/transportadoras" element={<ListagemDeTransportadoras />} />
      <Route path="/transportadoras/:id" element={<DetalheDaTransportadora />} />
      <Route path="/veiculos" element={<ListagemDeVeiculos />} />
      <Route path="/veiculos/:id/:idTransportadora" element={<DetalheDeVeiculos />} />
      <Route path="/reboques" element={<ListagemDeReboques />} />
      <Route path="/reboques/:id/:idTransportadora" element={<DetalheDeReboques />} />

      <Route path="/contabancaria" element={<ListagemDeContaBancaria />} />
      <Route path="/contabancaria/:id" element={<DetalheDeContaBancaria />} />

      <Route path="/planocontas" element={<PlanoDeContas />} />

      <Route path="/inicio" element={<PaginaInicial />} />

      <Route path="/" element={<Navigate to="/inicio" replace />} />

      <Route path="*" element={<Navigate to="/inicio" replace />} />
    </Routes>
  );
};